import { OsmProvider } from './osm'

export interface LatLng {
  lat: number
  lng: number
}

export interface MapMountOpts {
  center: LatLng
  zoom: number
}

export interface GeoJsonFeatureCollection {
  type: 'FeatureCollection'
  features: Array<{
    type: 'Feature'
    geometry: { type: string; coordinates: unknown }
    properties: Record<string, unknown>
  }>
}

export interface ZoneLayer {
  id: string
  geoJson: GeoJsonFeatureCollection
  fillColor?: string
  occupancy?: number
}

export interface ZoneMarker {
  id: string
  label: string
  lat: number
  lng: number
}

export interface MapProvider {
  mount(el: HTMLElement, opts: MapMountOpts): Promise<void>
  unmount(): void
  setZones(layer: ZoneLayer): void
  setMarkers(markers: ZoneMarker[]): void
  setCenter(center: LatLng, zoom?: number): void
  on(event: 'zone-click', handler: (zoneId: string) => void): void
}

let cached: MapProvider | null = null

export function getMapProvider(): MapProvider {
  if (cached) return cached
  // Swap implementation here when xaritam.uz is ready.
  cached = new OsmProvider()
  return cached
}
